<template>
    <div class="row">
    	<div class="col-12">
            <ul class="fixedMiddleHeaderTab d-flex align-items-center holderCss">
                <li :class="tab == 'Market-Insights'? 'active': ''" v-on:click.prevent="changeTab('Market-Insights')"><a href="#">{{$t('re_marketinsight')}}</a></li>
                <li :class="tab == 'News'? 'active': ''" v-on:click.prevent="changeTab('News')"><a href="#">{{$t('re_news')}}</a></li>
                <!-- <li :class="tab == 'Learn-to-Trade'? 'active': ''" v-on:click.prevent="changeTab('Learn-to-Trade')"><a href="#">Learn to Trade</a></li> -->
                <li :class="tab == 'Video-Tutorials'? 'active': ''" v-on:click.prevent="changeTab('Video-Tutorials')"><a href="#">Video Tutorials</a></li>
                <li :class="tab == 'Webinars'? 'active': ''" v-on:click.prevent="changeTab('Webinars')"><a href="#">Webinars</a></li>
                <li :class="tab == 'Forex'? 'active': ''" v-on:click.prevent="changeTab('Forex')"><a href="#">Forex Glossary</a></li>
            </ul>
        </div>
        <div class="col-12" v-if="tab == 'Market-Insights'">
            <app-MarketInsight></app-MarketInsight>
        </div>
	    <div class="col-12" v-if="tab == 'News'">
	    	<app-news></app-news>
	    </div>
        <div class="col-12" v-if="tab == 'Learn-to-Trade'">
        	<app-BasicEducation></app-BasicEducation>
        </div>
        <div class="col-12"  v-if="tab == 'Video-Tutorials'">
	       <app-videoTutorials></app-videoTutorials>
	    </div>
	    <div class="col-12" v-if="tab == 'Webinars'">
	    	<app-webinar></app-webinar>
	    </div>
        <div class="col-12" v-if="tab == 'Forex'">
            <app-ForexGlossary></app-ForexGlossary>
        </div>
	    
    </div>
</template>
<script>
    import marketInsight from './pages/market_insight'
    import BasicEducation from './pages/basic_education'
    import videoTutorials from './pages/video_tutorials'
    import webinar from './pages/webinar_fxview'
    import news from './pages/market_news'
     import forexGlossary from './pages/forex_glossary'
    export default {
        name: 'Wallet',
        data() {
            return {
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                fxsymbolprice : 1,
                tab : '',

            }
        },
		components:{
			appBasicEducation : BasicEducation,
            appVideoTutorials : videoTutorials,
            appWebinar : webinar,
            appNews : news,
            appMarketInsight : marketInsight,
            appForexGlossary :forexGlossary
		},
        methods:{
            changeTab(element){
                this.tab = element
                this.$router.replace({ name: "research_and_education", params: {tabName:element}})
            }
        },
        created(){
            this.tab = this.$route.params.tabName
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/research/research_and_education.vue